// extracted by mini-css-extract-plugin
export var deliveryRow = "_je-a";
export var fixedHeight = "_je-4";
export var freightLogo = "_je-9";
export var fullWidth = "_je-3";
export var priceColumn = "_je-5";
export var radioSelected = "_je-7";
export var radioUnselected = "_je-6";
export var selectedOption = "_je-2";
export var selectedOptionContainer = "_je-1";
export var selection = "_je-0";
export var tallSkeletonText = "_je-8";